function initiateEvaluationsStep(evaluations) {
  return evaluations ? evaluations.filter(Boolean) : null;
}

export { initiateEvaluationsStep };
